<template>
  <v-img
    :src="src"
    class="blur"
    :class="{ roundedCorners: rounded, 'align-items-center': vertical, shadow }"
    height="100%"
    :max-height="maxHeight"
    border
  >
    <template v-slot:placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular indeterminate></v-progress-circular>
      </v-row>
    </template>
    <div class="overlay">
      <slot></slot>
    </div>
    <router-link v-if="to" :to="to">
      <v-img v-bind="mainPosterProps"></v-img>
    </router-link>
    <v-img v-else v-bind="mainPosterProps"> </v-img>
  </v-img>
</template>

<script>
export default {
  name: "blurred-margin-poster",

  props: {
    src: String,
    to: Object,
    aspect: Number,
    maxHeight: Number,
    rounded: Boolean,
    vertical: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    mainPosterProps() {
      return {
        src: this.src,
        class: { "main-poster": true, "link-active": !!this.to },
        "aspect-ratio": this.aspect,
        height: this.vertical ? null : "100%",
        width: this.vertical ? "100%" : null,
        contain: !this.aspect,
      };
    },
  },

  methods: {
    handlePosterClicked() {
      if (this.to) {
        this.$router.push(this.to);
      }
    },
  },
};
</script>

<style>
.blur.shadow {
  box-shadow: 0 0 5px black;
}

.blur > .v-image__image--cover {
  filter: blur(10px);
  transform: scale(1.1);
}

.blur.roundedCorners {
  border-radius: 4px;
}

.blur .overlay > * {
  pointer-events: auto;
}
</style>

<style scoped>
.blur.align-items-center {
  align-items: center;
}

.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
  top: 0;
}

.main-poster {
  z-index: 2;
}

.main-poster.link-active:hover {
  cursor: pointer;
}
</style>
